var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-area"},[_c('audio-player',{ref:"audioPlayer",attrs:{"audio-list":[_vm.url]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }